import { render, staticRenderFns } from "./PromotedUserItem.vue?vue&type=template&id=1e2c016c&scoped=true&"
import script from "./PromotedUserItem.vue?vue&type=script&lang=ts&"
export * from "./PromotedUserItem.vue?vue&type=script&lang=ts&"
import style0 from "./PromotedUserItem.vue?vue&type=style&index=0&id=1e2c016c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c016c",
  null
  
)

export default component.exports